import { AxiosInstance } from "axios";
import Asset from "../models/Asset";
import AssetCreationResult from "../models/AssetCreationResult";
import {blobToBase64} from "../utils/PdfUtils";

export default class AssetsApi {
    constructor(public readonly axiosInstance: AxiosInstance) {}

    fetchAssets(siteId: number, assetTypeId: number): Promise<Asset[]> {
        const url = `/api/assets?siteId=${siteId}&assetTypeId=${assetTypeId}`;
        return this.axiosInstance.get(url).then(resp => resp.data.map(Asset.fromJson));
    }

    postNewAsset(siteId: number, assetTypeId: number): Promise<AssetCreationResult> {
        const url = `/api/${siteId}/assets`;
        const body = { assetTypeId };

        return this.axiosInstance.post(url, body)
            .then(resp => {
                return AssetCreationResult.fromJson(resp.data);
            })
            .catch(err => {
                throw err;
            });
    }

    async postAssetSummaryAttachment(siteId: number, attachmentFile: File): Promise<Response> {
        const url = `/api/companies/site/${siteId}`;
        const base64Data = (await blobToBase64(attachmentFile)).split(",")[1].toString();
        const body = { fileName: attachmentFile.name, base64Data: base64Data };
        return await this.axiosInstance.post(url, body);
    }
}